import React from 'react';
import CoWorkingEventList from '../components/CoWorkingEventList';

const Events: React.FC = () => {
    return (
        <CoWorkingEventList showButton={false} addMargin={true} />
    );
};

export default Events;
